import React from 'react'
import Select, { MultiValue } from 'react-select'
import styled from 'styled-components'
import { defs } from 'components/Shared/defs'
import { device } from 'components/Shared/device'
import { useVndlyIssuesContextValue } from '../context/VndlyIssuesProvider'

type Option = { label: string; value: number }

const findSelectedOptions = (options: Option[], values: number[] | null) =>
  values ? options.filter((o) => values.includes(o.value)) : []

const toValues = (selected: MultiValue<Option>) =>
  selected.length ? selected.map((o) => o.value) : null

export const VndlyIssuesFilterBar = () => {
  const {
    state: { instances, filters },
    actions: { setFilters },
  } = useVndlyIssuesContextValue()

  const instanceOptions: Option[] = instances.map((instance) => ({
    label: instance.instanceUrl,
    value: instance.id,
  }))

  const companyOptions: Option[] = instances
    .filter(
      (instance) =>
        !filters.instanceIds || filters.instanceIds.includes(instance.id)
    )
    .flatMap((instance) => instance.companies)
    .map((company) => ({
      label: `${company.name} (${company.id})`,
      value: company.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <FilterBarWrapper showBorderTop showBorderBottom>
      <SelectGroup>
        <Select
          isMulti
          isClearable
          isSearchable
          options={instanceOptions}
          styles={customStyles}
          name="instanceIds"
          placeholder="Instance"
          value={findSelectedOptions(instanceOptions, filters.instanceIds)}
          onChange={(selected) =>
            setFilters({ instanceIds: toValues(selected) })
          }
          closeMenuOnSelect={false}
        />
        <Select
          isMulti
          isClearable
          isSearchable
          options={companyOptions}
          styles={customStyles}
          name="companyIds"
          placeholder="Company"
          value={findSelectedOptions(companyOptions, filters.companyIds)}
          onChange={(selected) =>
            setFilters({ companyIds: toValues(selected) })
          }
          closeMenuOnSelect={false}
        />
      </SelectGroup>
    </FilterBarWrapper>
  )
}

const customStyles = {
  container: (provided: Record<string, unknown>) => ({
    ...provided,
    minWidth: 220,
    marginRight: defs.marginM,
    marginTop: defs.marginXS,
    marginBottom: defs.marginXS,
    fontSize: defs.fontS,
  }),
}

const FilterBarWrapper = styled.div<{
  showBorderTop?: boolean
  showBorderBottom?: boolean
}>`
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid' : null)};
  border-top: ${(props) => (props.showBorderTop ? '1px solid' : null)};
  border-color: ${defs.veryLightBlack};
  padding: ${defs.paddingS};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  @media ${device.smallerThanMobileL} {
    font-size: ${defs.fontS};
    height: 100%;
    padding-left: ${defs.paddingM};
  }
`

const SelectGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`
